import { washNesTabTwo } from '@/utils/wash.js'
export const washData = (node) => {
  washNesTabTwo(node)
}
